import Vue from 'vue';
import Vuex from 'vuex';
import GameLogic, {
    FeedbackRecord,
    Hotspot,
    HotspotOption,
    HotspotOptionRecord,
    PatientFeedbackState
} from "@/services/GameLogic";
//import * as Logic from "@/services/LogicService"; // okee dat werkt dan ook opeens weer niet, want fuck consistentie
import ContentService from "@/services/ContentService";
import {EndVideoInfo} from "@/store/ContentTypes";

Vue.use(Vuex);

export enum MoodState { wit, groen, oranje, rood, zwart }

export enum WhiteBoardState { empty, monday, tuesday, wednesday, thursday }

export enum ClockState { removed, noBattery, unused, working }

export enum BlindsState { closed, opened }

export enum TalkToPatientState { inactive, talkedto, talkedto2, finalized } // alleen 0, 1 gebruikt

export enum Locale { nl = 'nl_NL', en = 'en_GB' }

export enum ViewportState { hidden = "hidden", center = "center", follow = "follow", shade = "shade" }

class DayState {
    turnBudget: number;
    turnsLeft: number;
    score: number;
    log: HotspotOptionRecord[];
    patientIgnored: boolean;
    feedback: FeedbackRecord[];
    patientVideoViewed: boolean;

    constructor() {
        this.turnBudget = 0.0;
        this.turnsLeft = 0.0;
        this.score = 0;
        this.log = [];
        this.patientIgnored = false;
        this.feedback = [];
        this.patientVideoViewed = false;
    }
}

export enum TutorialTipPosition { center = 'v-center', top = 'v-top', bottom = 'v-bottom' }

export interface TutorialTipInfo {
    key:string,
    position: TutorialTipPosition
}

class TutorialState {
    currentTip:TutorialTipInfo;
    tipHistory:TutorialTipInfo[];

    public static NONE:TutorialTipInfo = <TutorialTipInfo> { key: '', position: TutorialTipPosition.center }

    constructor() {
        this.currentTip = TutorialState.NONE;
        this.tipHistory = [];
    }
}

const playerModule = {};

export class DelierState {
    day: number = 0;
    mood: MoodState = MoodState.oranje;
    whiteBoard: WhiteBoardState = WhiteBoardState.empty;
    clock: ClockState = ClockState.noBattery;
    dayState: DayState = new DayState;
    locale: Locale = Locale.nl;
    blinds: BlindsState = BlindsState.closed;
    communicateState: number = 0;
    viewportScale: number = 1.0;
    currentHotspot: Hotspot = Hotspot.NONE;
    currentOption: HotspotOption = HotspotOption.NONE;
    showExitConfirm: boolean = false;
    endFeedback: EndVideoInfo[] = [];
    endTips: any = {}; // hashset
    tutorialState: TutorialState = new TutorialState;

    // brilState: number = 0; // TODO: uitzoeken wat dit is
    // ontbijtState: number = 0; // TODO: uitzoeken wat dit is
    // infuusState: number = 0; // TODO: uitzoeken wat dit is
    // medicatieState: number = 0; // TODO: uitzoeken wat dit is
    // talkToSurgeonState: number = 0; // TODO: uitzoeken wat dit is
}

export default new Vuex.Store({
    state: new DelierState,
    mutations: {
        resetGame(state):void {
            state.whiteBoard = WhiteBoardState.empty;
            state.clock = ClockState.noBattery;
            state.mood = MoodState.oranje;
            state.blinds = BlindsState.closed;
            state.communicateState = 0;
            state.day = 0;
            state.dayState = new DayState;
            state.endTips = {};
            state.tutorialState = new TutorialState;
        },
        startDay(state):void {
            const situation = GameLogic.getSituationObject(state);
            state.dayState = new DayState;
            state.dayState.turnBudget = state.dayState.turnsLeft = situation.situation.availableUnits;
            //state.dayState.talkedToPatientState = situation.situation.patientState;
            if( situation.situation.blindsState != undefined ) {
                state.blinds = situation.situation.blindsState;
            } else {
                state.blinds = BlindsState.closed;
            }
            state.communicateState = situation.situation.patientState;
            state.currentHotspot = Hotspot.NONE;
            state.currentOption = HotspotOption.NONE;
            //console.log('startDay', state.dayState.turnsLeft, '/', state.dayState.turnBudget);
        },
        processPatientMood(state):void {
            const oldMood = state.mood;
            const situation = GameLogic.getSituationObject(state);

            // update mood
            if( state.dayState.score < situation.situation.score.min ) {
                // worsen mood
                GameLogic.deltaMood(state, +1);
            }else if( state.dayState.score >= situation.situation.score.max ) {
                // worsen mood
                GameLogic.deltaMood(state, -1);
            }
            //console.log('processPatientMood', MoodState[oldMood], '-->', MoodState[state.mood]);
        },
        closeCurtains(state):void {
            state.blinds = BlindsState.closed;
        },
        openCurtains(state):void {
            state.blinds = BlindsState.opened;
        },
        clearWhiteBoard(state):void {
            state.whiteBoard = WhiteBoardState.empty;
        },
        updateWhiteBoard(state):void {
            switch( state.day ) {
                case 0: {
                    state.whiteBoard = WhiteBoardState.monday;
                    break;
                }
                case 1: {
                    state.whiteBoard = WhiteBoardState.tuesday;
                    break;
                }
                case 2: {
                    state.whiteBoard = WhiteBoardState.wednesday;
                    break;
                }
                case 3: {
                    state.whiteBoard = WhiteBoardState.thursday;
                    break;
                }
            }
        },
        removeClock(state, getters):void {
            state.clock = ClockState.removed;
            getters.currentIntroVideo(state);
        },
        replaceClockBattery(state):void {
            state.clock = ClockState.working;
        },
        patientMoodUp(state):void {
            if( state.mood  == MoodState.rood ) state.mood = MoodState.oranje;
            else if( state.mood == MoodState.oranje ) state.mood = MoodState.groen;
        },
        patientMoodDown(state):void {
            if( state.mood  == MoodState.groen ) state.mood = MoodState.oranje;
            else if( state.mood == MoodState.oranje ) state.mood = MoodState.rood;
        },
        setDay(state, day:number):void {
            state.day = day;
        },
        showTip(state, info:TutorialTipInfo):void {
            if( state.tutorialState.currentTip.key === '' && !GameLogic.hasSeenTip(state, info.key) ) {
                console.log('showTip', info);
                state.tutorialState.tipHistory.push(info);
                state.tutorialState.currentTip = info;
            }
        },
        hideTip(state, key:string):void {
            if( state.tutorialState.currentTip.key === key ) {
                console.log('hideTip', key);
                state.tutorialState.currentTip = TutorialState.NONE;
            }
        },
        hideAnyTip(state):void {
            if( state.tutorialState.currentTip.key !== '' ) {
                console.log('hideAnyTip', state.tutorialState.currentTip);
                state.tutorialState.currentTip = TutorialState.NONE;
            }
        },
        disableTip(state, key:string):void {
            if( !GameLogic.hasSeenTip(state, key) ) {
                console.log('disableTip', key);
                state.tutorialState.tipHistory.push({key: key, position: TutorialTipPosition.center});
            }
        }
    },
    getters: {
        hasSeenTip: state => (key:string) => {
            return GameLogic.hasSeenTip(state, key);
        },
        situation(state:DelierState):number {
            return GameLogic.situationFromDayAndMood(state.day, state.mood);
        },
        currentIntroVideo: state => {
            return GameLogic.getIntroVideo(state);
        },
        currentSlotVideo: state => {
            return GameLogic.getSlotVideo(state);
        },
        availableUnits: state => {
            const situationIndex = GameLogic.situationFromDayAndMood(state.day, state.mood);
            const situationObject = ContentService.situations[situationIndex];
            return situationObject.situation.availableUnits;
        }
    }
});
